import { Box, Grid, Typography } from '@mui/material';

function Heading({ children, heading, showDivider = true }) {
  return (
    <Box>
      <Grid
        container
        spacing={2}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Grid size={{ xs: 12 }} sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant='h4'>{heading}</Typography>
        </Grid>
        {children && (
          <Grid size={{ xs: 12 }} sx={{ width: { xs: '100%', sm: 'auto' } }}>
            <Box
              sx={{
                width: { xs: '100%', sm: 'auto' },
                display: 'flex',
                justifyContent: { xs: 'stretch', sm: 'flex-end' },
                '& > *': {
                  width: { xs: '100%', sm: 'auto' },
                },
              }}
            >
              {children}
            </Box>
          </Grid>
        )}
      </Grid>
      {showDivider && <hr />}
    </Box>
  );
}

export default Heading;
